var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeamx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13794 9.02344V11.4844H15.9655H28.7931V9.02344V6.5625H15.9655H3.13794V9.02344Z",
    fill: "url(#paint0_linear_986_4891)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13794 13.9453V16.4062H15.9655H28.7931V13.9453V11.4844H15.9655H3.13794V13.9453Z",
    fill: "url(#paint1_linear_986_4891)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13794 18.8672V21.3281H15.9655H28.7931V18.8672V16.4062H15.9655H3.13794V18.8672Z",
    fill: "url(#paint2_linear_986_4891)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13794 23.7891V26.25H15.9655H28.7931V23.7891V21.3281H15.9655H3.13794V23.7891Z",
    fill: "url(#paint3_linear_986_4891)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_986_4891",
    x1: 15.9655,
    y1: 11.4844,
    x2: 15.9655,
    y2: 6.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_986_4891",
    x1: 15.9655,
    y1: 16.4062,
    x2: 15.9655,
    y2: 11.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_986_4891",
    x1: 15.9655,
    y1: 21.3281,
    x2: 15.9655,
    y2: 16.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#B9B9B9",
    stopOpacity: 0.785714
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_986_4891",
    x1: 15.9655,
    y1: 26.25,
    x2: 15.9655,
    y2: 21.3281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeamx);
export default __webpack_public_path__ + "static/media/BEAMX.4cae7d3d78fd110dcde3b990c40c7d83.svg";
export { ForwardRef as ReactComponent };